



















































































































































































































































































































































































































import { DemandeAccessPlateformeBeneficiaire } from "@/api/models/accesPlateformeBeneficiaires/demandeAccessPlateformeBeneficiaire";
import { PaginatedList } from "@/api/models/common/paginatedList";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import {
  BAlert,
  BBadge,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BModal,
  BPagination,
  BRow,
  BSpinner,
  BTable,
} from "bootstrap-vue";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    BAlert,
    BBadge,
    BButton,
    BCard,
    BCol,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BModal,
    BPagination,
    BRow,
    BSpinner,
    BTable,
  },
})
export default class DemandesAccesList extends Vue {
  // États du composant
  isLoading = false;
  showDetailsModal = false;
  selectedDemande: DemandeAccessPlateformeBeneficiaire | null = null;
  
  // Modal de traitement
  showTreatmentModal = false;
  treatmentData = {
    demandeId: null as string | null,
    accepte: false,
    commentaire: ""
  };
  commentaireError = "";
  commentaireState: boolean | null = null;

  // Paramètres de pagination et tri
  perPage = 10;
  currentPage = 1;
  perPageOptions = [5, 10, 25, 50, 100];
  timeout: any = null;
  searchQuery = "";
  isSortDirDesc = true; // Par défaut, tri décroissant (plus récent en premier)
  sortBy = "dateDemande"; // Par défaut, tri par date de demande
  includeTraitees = false; // Par défaut, n'afficher que les non traitées

  // Colonnes du tableau
  tableColumns = [
    { key: "nom", label: "Nom", sortable: true },
    { key: "prenom", label: "Prénom", sortable: true },
    { key: "email", label: "Email", sortable: true },
    { key: "telephone", label: "Téléphone", sortable: false },
    { key: "dateDemande", label: "Date de demande", sortable: true },
    { key: "statut", label: "Statut", sortable: false },
    { key: "entreprise", label: "Entreprise", sortable: true },
    { key: "entrepriseAdherente", label: "Adhérente ?", sortable: false },
    { key: "actions", label: "Actions", sortable: false },
  ];

  // Données
  paginatedListDemandes = new PaginatedList<DemandeAccessPlateformeBeneficiaire>();

  // Propriétés calculées pour la pagination
  get paginationFrom() {
    return (
      this.perPage * (this.currentPage - 1) +
      (this.paginatedListDemandes.items.length ? 1 : 0)
    );
  }

  get paginationTo() {
    return (
      this.perPage * (this.currentPage - 1) +
      this.paginatedListDemandes.items.length
    );
  }

  // Propriété calculée pour valider le commentaire
  get isCommentaireValid() {
    return this.treatmentData.commentaire && 
           this.treatmentData.commentaire.trim().length >= 10;
  }

  // Propriété calculée pour vérifier les droits de traitement
  get canUpdateDemandes() {
    return this.$can('PTF_BENEFICIAIRE_DEMANDEACCES:update');
  }

  // Lifecycle hooks
  async created() {
    await this.loadListDemandes();
  }

  // Watchers pour la pagination
  @Watch("currentPage")
  @Watch("perPage")
  @Watch("includeTraitees")
  async paginationChanged() {
    await this.loadListDemandes();
  }

  // Watchers pour la recherche et le tri
  @Watch("searchQuery")
  @Watch("sortBy")
  @Watch("isSortDirDesc")
  async searchDemandes() {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      this.currentPage = 1; // Reset à la première page lors d'une recherche
      await this.loadListDemandes();
    }, 500);
  }

  // Watcher pour la validation du commentaire en temps réel
  @Watch("treatmentData.commentaire")
  validateCommentaire() {
    if (this.treatmentData.commentaire) {
      const trimmedComment = this.treatmentData.commentaire.trim();
      
      if (trimmedComment === '') {
        this.commentaireError = "Le commentaire est obligatoire pour traiter une demande.";
        this.commentaireState = false;
      } else if (trimmedComment.length < 10) {
        this.commentaireError = "Le commentaire doit contenir au moins 10 caractères.";
        this.commentaireState = false;
      } else {
        this.commentaireError = "";
        this.commentaireState = true;
      }
    } else {
      this.commentaireError = "Le commentaire est obligatoire pour traiter une demande.";
      this.commentaireState = false;
    }
  }

  // Méthodes
  async loadListDemandes() {
    this.isLoading = true;
    
    try {
      const response = await this.$http.myressif.demandeAccesPtfBeneficiaire.search(
        this.currentPage,
        this.perPage,
        this.sortBy,
        this.isSortDirDesc,
        this.includeTraitees
      );
      
      this.paginatedListDemandes = response;
    } catch (error: any) {
      errorAlert.fire({
        title: "Erreur de chargement",
        text: "Impossible de charger les demandes d'accès auprès de l'espace bénéficiaire.",
      });
    } finally {
      this.isLoading = false;
    }
  }

  updateSort(params: any) {
    this.sortBy = params.sortBy;
    this.isSortDirDesc = !this.isSortDirDesc;
    this.loadListDemandes();
  }

  async refreshData() {
    await this.loadListDemandes();
    successAlert.fire({
      title: "Actualisation",
      text: "Les données ont été actualisées avec succès.",
      timer: 2000,
    });
  }

  openDetailsModal(demande: DemandeAccessPlateformeBeneficiaire) {
    this.selectedDemande = demande;
    this.showDetailsModal = true;
  }

  openTreatmentModal(demandeId: string, accepte: boolean) {
    this.treatmentData = {
      demandeId: demandeId,
      accepte: accepte,
      commentaire: ""
    };
    this.commentaireError = "";
    this.commentaireState = null;
    this.showTreatmentModal = true;
  }

  cancelTreatment() {
    this.showTreatmentModal = false;
    this.treatmentData = {
      demandeId: null,
      accepte: false,
      commentaire: ""
    };
    this.commentaireError = "";
    this.commentaireState = null;
  }

  async confirmTreatment() {
    if (!this.treatmentData.demandeId) return;

    // Validation du commentaire obligatoire
    if (!this.treatmentData.commentaire || this.treatmentData.commentaire.trim() === '') {
      this.commentaireError = "Le commentaire est obligatoire pour traiter une demande.";
      this.commentaireState = false;
      return;
    }

    // Le commentaire doit avoir au moins 10 caractères
    if (this.treatmentData.commentaire.trim().length < 10) {
      this.commentaireError = "Le commentaire doit contenir au moins 10 caractères.";
      this.commentaireState = false;
      return;
    }

    // Validation réussie
    this.commentaireState = true;
    this.commentaireError = "";

    try {
      await this.$http.myressif.demandeAccesPtfBeneficiaire.update(
        this.treatmentData.demandeId, 
        this.treatmentData.accepte,
        this.treatmentData.commentaire
      );
      
      await this.loadListDemandes();

      // Fermer la modale
      this.showTreatmentModal = false;
      this.showDetailsModal = false;

      successAlert.fire({
        title: "Statut mis à jour",
        text: `La demande a été ${this.treatmentData.accepte ? 'acceptée' : 'refusée'}.`,
        timer: 2000,
      });

      // Reset des données
      this.treatmentData = {
        demandeId: null,
        accepte: false,
        commentaire: ""
      };
      this.commentaireError = "";
      this.commentaireState = null;

    } catch (error: any) {
      errorAlert.fire({
        title: "Erreur",
        text: "Impossible de mettre à jour le statut de la demande.",
      });
    }
  }



  formatDate(dateString: string): string {
    if (!dateString) return '';
    
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return dateString;
    }
  }
}
